import {
  checkCheckboxes,
  configureCheckAllCheckbox,
  uncheckCheckboxes,
} from '../../components/checkbox'

function configureApiUserDropDown(dropDown: HTMLSelectElement) {
  dropDown.addEventListener('change', () => {
    const userId = dropDown.value
    const param = new URLSearchParams(location.search)
    if (!isNaN(parseInt(userId))) {
      param.set('api_token_user', userId)
    } else if (param.has('api_token_user')) {
      param.delete('api_token_user')
    }
    location.search = param.toString()
  })
}

function initApiOptions() {
  const apiUserDropDown = document.getElementById(
    'id_api_user',
  ) as HTMLSelectElement
  if (apiUserDropDown) {
    configureApiUserDropDown(apiUserDropDown)
  }
  const checkAll = document.getElementById(
    'id_subscribe_to_all_types',
  ) as HTMLInputElement
  const checkboxes = document.querySelectorAll(
    'input.check-item',
  ) as NodeListOf<HTMLInputElement>

  if (checkAll) {
    checkAll.addEventListener('change', () => {
      if (checkAll.checked) {
        checkCheckboxes(checkboxes)
      } else {
        uncheckCheckboxes(checkboxes)
      }
    })
    configureCheckAllCheckbox(checkAll, checkboxes)
  }
}

export { initApiOptions }
